import React, { useEffect } from "react";
import {
    changeAddressAll,
    changeAddress2All,
    changeSuiteRoomAll,
} from "./../CanvasActions";
import TextField from "./../Form/TextField";
import SelectField from "./../Form/SelectField";

const FormP11T24 = React.memo((props) => {
    useEffect(() => {
        changeAddressAll(props.address);
    }, [props.address]);

    useEffect(() => {
        changeAddress2All(props.address2);
    }, [props.address2]);

    useEffect(() => {
        changeSuiteRoomAll(props.suiteRoom);
    }, [props.suiteRoom]);

    return (
        <form action="" className="envelopes-fields">
            <hr />
            <TextField
                required
                label="Address"
                value={props.suiteRoom}
                setFunction={props.setSuiteRoom}
                placeholder="Example: 6431 Fannin Street, Suite 1880"
            />
            <TextField
                required
                label="City, State, Zip"
                value={props.address2}
                setFunction={props.setAddress2}
                placeholder="Example: Houston, Texas 77030"
            />
            <hr />
            <SelectField
                required
                label="Window Envelope"
                value={props.window}
                setFunction={props.setWindow}
                options={[
                    { value: 1, label: "Yes" },
                    { value: 0, label: "No" },
                ]}
            />
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: "", label: "Select option" },
                    { value: "250", label: "250" },
                    { value: "500", label: "500" },
                    { value: "1000", label: "1000" },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div>
                    <span className="label">Title:</span> UTHealth Houston |
                    UTHealth Behavioral Sciences Business A6 Envelopes
                </div>
                <div className="description-list">
                    <span className="label">Description:</span>
                    <ul>
                        <li>Flat: A6 envelope</li>
                        <li>Stock: 100# Opaque White Cover</li>
                        <li>Printed: One Side</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

export default FormP11T24;
